import { Inject, Injectable } from '@angular/core';

import { BetslipConfig } from '@frontend/sports/common/client-config-data-access';
import { StringInterpolationPipe } from '@frontend/sports/common/core/utils/string-interpolation';

import { IBetslipMessages } from '../../../base/models/betslip-messages';
import { BETSLIP_MESSAGES_PROVIDER_INJECTION_TOKEN, IBetslipMessagesProviderService } from '../../../base/services/betslip-messages-provider.service';

const enum SystemNameType {
    Default = 'Default',

    UK = 'UK',

    US = 'US',
}

@Injectable()
export default class SystemBetsService {
    private messages: IBetslipMessages;

    constructor(
        @Inject(BETSLIP_MESSAGES_PROVIDER_INJECTION_TOKEN) messageProvider: IBetslipMessagesProviderService,
        private betslipConfig: BetslipConfig,
        private interpolatePipe: StringInterpolationPipe,
    ) {
        this.messages = messageProvider.getMessages();
    }

    getSystemBasicName(combinationsLenght: number, picksCount: number, useAltTranslation?: boolean): string {
        const messages = useAltTranslation ? this.messages.systemBets.altNames : this.messages.systemBets.names;

        switch (this.betslipConfig.systemBetsNameType) {
            case SystemNameType.UK:
                switch (combinationsLenght) {
                    case 2:
                        return messages.doubles;
                    case 3:
                        return messages.trebles;
                    default:
                        return this.interpolatePipe.transform(messages.defaultUK, {
                            comboLenght: combinationsLenght,
                        });
                }
            case SystemNameType.US:
                return this.interpolatePipe.transform(messages.defaultUS, {
                    comboLenght: combinationsLenght,
                    picksCount,
                });
            default:
                return this.interpolatePipe.transform(messages.default, {
                    comboLenght: combinationsLenght,
                    picksCount,
                });
        }
    }

    getSystemFullName(key: string, useAltTranslation?: boolean): string {
        const messages = useAltTranslation ? this.messages.systemBets.altNames : this.messages.systemBets.names;

        return messages[key as keyof typeof messages];
    }
}
